import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormInfoService } from '../../services/form-info.service';
import { StateService } from '../../services/state.service';
import { TealiumService } from '../../services/tealium.service';
import { SubNavItem } from '@autonation/dt-an-components-lib/an-sub-nav';
import { VehicleDetailsService } from '../../services/vehicle-details.service';
import { CookieService } from 'ngx-cookie';

@Component({
    selector: 'an-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {

  vehicleCounts: { value: number; label: string }[] = [];

  constructor(
    private _formInfo: FormInfoService,
    private _stateData: StateService,
    private tealium: TealiumService,
    private _vehicleDetails: VehicleDetailsService,
    private ref: ChangeDetectorRef, 
    private _cookieService: CookieService
  ) { }
  showBanner = true;

  subnavItems: SubNavItem[];

  ngOnInit() {
    const tealiumAccount = this._stateData.state.Sitecore.TealiumSettings.TealiumAccount;
    const tealiumProfile = this._stateData.state.Sitecore.TealiumSettings.TealiumProfile;
    const tealiumEnv = this._stateData.state.Sitecore.TealiumSettings.TealiumENV;

    this.subnavItems = this._stateData.state?.Sitecore?.labels?.SubnavItems || [];
    
    if (tealiumAccount && tealiumProfile && tealiumEnv) {
      this.tealium.setConfig({
        account: tealiumAccount,
        profile: tealiumProfile,
        environment: tealiumEnv
      });
    } else {
      console.error('Tealium config not set')
    }
    this._stateData.showBannerComp.subscribe((item) => {
      this.showBanner = item;
    });


    this.loadVehicleCounts();
  }

  onSelectItem(e: any) {
    console.log(e)
    this._formInfo.subNavMenuClick(e.name);
    window.location.href = e.redirectTo;
  }

  loadVehicleCounts() {
    this._vehicleDetails.favVehicleDetails.subscribe(x => {
      let vehicles = x.filter(x => x.inventoryStatus !== 'G' && x.isValidVin);
      let reservedCount = x.filter(x => x.inventoryStatus === 'ANR').length;
      let SoldCount = x.filter(x => x.inventoryStatus === 'G' || !x.isValidVin).length;
      let vehicleCount = x.length - reservedCount - SoldCount;
      // this.ref.markForCheck();

      let counts = [
        { value: vehicleCount, label: 'Available' },
        // { value: 13, label: 'Available' },
        { value: reservedCount, label: 'Reserved' },
        // { value: 2, label: 'Reserved' },
        { value: SoldCount, label: 'Sold' }
        // { value: 3, label: 'Sold' }
      ];

      this.vehicleCounts = counts.filter(item => item.value > 0);
      this.ref.detectChanges();

      let showSavedVehicleCountEvent = new CustomEvent("saved-vehicle-count", { detail: vehicles.length });
      document.dispatchEvent(showSavedVehicleCountEvent);
      this._cookieService.put('FavoritesCount', vehicles.length.toString());
    });
  }

}
